import { RouteConfigProvider } from '@/context/route-config';
import PersonalInformationForm, { type PersonalInformationRouteConfig } from '@/features/onboarding/personal-information/components/form';
import PersonalInformationLayout from '@/features/onboarding/personal-information/layout';
import { PERIODIC_REVIEW_PATHS } from '@/features/periodic-review/constants';

const ROUTE_CONFIG = {
  fcaQuestionnaire: PERIODIC_REVIEW_PATHS.FCA_QUESTIONNAIRE,
  forbiddenJurisdiction: PERIODIC_REVIEW_PATHS.FORBIDDEN_JURISDICTION,
  next: PERIODIC_REVIEW_PATHS.NATIONAL_CLIENT_IDENTIFIER,
  summary: PERIODIC_REVIEW_PATHS.SUMMARY,
} satisfies PersonalInformationRouteConfig;

const PeriodicReviewPersonalInformationPage = () => {
  return (
    <PersonalInformationLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <PersonalInformationForm />
      </RouteConfigProvider>
    </PersonalInformationLayout>
  );
};
PeriodicReviewPersonalInformationPage.displayName = 'PeriodicReviewPersonalInformationPage';

export default PeriodicReviewPersonalInformationPage;
